<template>
    <div class="navbar-header"
        v-if="showNavbarHeader()">

        <div class="navbar-header-inner">
            <a class="close"
                @click="hideNavbarBanner()"><i class="fas fa-times"></i></a>

            <div class="top-box-header-body">
                <div class="container">

                    <div class="row">
                        <div class="col-md-12">
                            <h5>
                                JETZT NEU!
                            </h5>


                            <!-- <p class="text-center mb-20">
                                Buchen Sie <strong>JETZT</strong> Ihren Urlaub im <a href="https://www.ostseeresortolpenitz.de/?utm_source=DFA&utm_medium=link&utm_campaign=DFAzuORO&utm_id=Text"
                                    target="_blank">OstseeResort Olpenitz!</a>
                                <br/> Inklusive Vorteil:
                            </p>-->

                        </div>
                    </div>
                    <div class="row first">
                        <div class="col-md-12 col-sm-12 col-xs-12 box">
                            <p>
                                Kostenfreie Stornierungsmöglichkeit bis 14 Tage vor Anreise &nbsp; <span>für Aufenthalte bis
                            zum 31. März 2023*</span>
                            </p>
                            <h6>
                                *nur gültig für Buchungen nach dem 03.09.2022
                            </h6>

                        </div>

                        <!-- <div class="col-md-4 col-sm-4 col-xs-12 box">
                        <p><i class="far fa-check-circle"></i> <strong>UND vorher?</strong> Mit SICHERHEIT <strong>KOSTENFREI</strong> bis 7 Tage vor Anreise stornieren (für Aufenthalte bis 31.03.2022)
                        </p>
                    </div> -->
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
    	voVueComponent: 'navbar-disrupter',

    	data() {
    		return {
    			navbarheader: true,
    		}
    	},
    	computed: {

    	},

    	methods: {
    		hideNavbarBanner() {
    				var d = new Date();
    				d.setTime(d.getTime() + (3 * 24 * 60 * 60 * 1000)); //3 days
    				var expires = "expires=" + d.toUTCString();
    				document.cookie = "navbarheader=true" + ";" + expires + ";path=/";
    				this.navbarheader = false;
    			},

    			showNavbarHeader() {
    				if (!this.navbarheader) {
    					return false;
    				}
    				var name = "navbarheader=";
    				var ca = document.cookie.split(';');
    				for (var i = 0; i < ca.length; i++) {
    					var c = ca[i];
    					while (c.charAt(0) == ' ') {
    						c = c.substring(1);
    					}
    					if (c.indexOf(name) == 0) {
    						return false;
    					}
    				}
    				return true;
    			},
    			showActivityFooter() {
    				$('html, body').animate({
    					scrollTop: $("#activity-footer").offset().top + 10
    				}, 0);
    			}

    	}
    }
</script>